export default __webpack_public_path__ + "static/media/title_zh_cn_pc@2x.75cf873f.png";